module.exports = __webpack_public_path__ + "img/4.eb46a06f.svg";